export default __webpack_public_path__ + "static/01-02-reading-annotation-exercises-7c7147c8acb98b6ff7208e06cf588a43.mp4";